<style lang="scss" scoped>
:host {
  min-height: 100vh;
  background-color: #f6f6f6;
}
.similar-container {
  width: 702px;
  margin: 24px auto;
  .similar-list {
    width: 702px;
    .similar-item {
      height: 200px;
      margin-bottom: 24px;
      background-color: #ffffff;
      display: flex;
      align-items: center;
      position: relative;
      .img-container {
        height: 200px;
        width: 200px;
        margin-right: 16px;
        .similar-img{
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
      .msg-container {
        flex: 1;
        display: flex;
        flex-direction: column;
        height: 200px;
        padding: 24px 16px;
        .brand {
          height: 38px;
          line-height: 38px;
          font-size: 24px;
          color: #262626;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .name {
          flex: 1;
          font-size: 24px;
          color: #262626;
          font-weight: bold;
          line-height: 34px;
          .msg {
            height: 68px;
            font-size: 24px;
            overflow: hidden;
          }
        }
        .price-container {
          height: 42px;
          width: 256px;
          line-height: 42px;
          color: #262626;
          display: flex;
          background: url('./../../../assets/images/ai-picture/price-bg.png') 0 0/100% 100% no-repeat;
          .price-swipe {
            height: 42px;
          }
          .price-item {
            display: flex;
            .label {
            width: 136px;
            height: 42px;
            padding-left: 4px;
            color: #2d2d2d;
            font-size: 24px;
            display: inline-block;
            // background: url('./../../../assets/images/ai-picture/price-bg-l.png') 0 0/100% 100% no-repeat;
          }
          .price {
            width: 136px;
            height: 42px;
            position: relative;
            left: -14px;
            padding-left: 20px;
            color: #1d1d1d;
            font-size: 24px;
            display: inline-block;
            // text-align: right;
            // background: url('./../../../assets/images/ai-picture/price-bg-r.png') 0 0/100% 100% no-repeat;
          }
          }
          
        }
      }
      .arrow-right {
        position: absolute;
        top: 24px;
        right: 24px;
        width: 30px;
        height: 30px;
      }
      .sale-num {
        position: absolute;
        bottom: 24px;
        right: 24px;
        color: #999999;
        font-size: 24px;
      }
    }
  }
}
.empty-err-page-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  // justify-content: center;
  height: calc(100vh - 0px);
  width: 100vw;
  // background-color: white;
  padding-top: 360px;
  box-sizing: border-box;
  max-height: 100%;
  .status-icon {
    width: 180px;
    height: 100px;
    margin-bottom: 48px;
    object-fit: contain;
  }
  .status-text {
    color: #333;
    font-size: 30px;
    line-height: 42px;
  }
  .status-link {
    color: #999;
    margin-top: 28px;
    font-size: 24px;
    line-height: 34px;
    text-decoration: underline;
  }
  .tips {
    color: #999;
    margin-top: 28px;
    font-size: 24px;
    line-height: 34px;
  }
}
</style>

<template>
  <div class="similar-container">
    <div v-if="errStatus == 1" class="empty-err-page-container">
      <!-- 网络异常情况 -->
      <img class="status-icon" src="https://oss.turingsenseai.com/1603512074441638739.png" />
      <span class="status-text">网络异常</span>
      <span class="status-link" @click='getSimilarList'>重新加载</span>
    </div>
    <div v-if="similarList.length == 0" class="empty-err-page-container">
      <!-- 暂无数据 -->
      <img class="status-icon" src="https://oss.turingsenseai.com/1597910745455776183.png" />
      <span class="tips">很抱歉，没有找到相似款式</span>
    </div>
    <div v-if="errStatus == 0 &&similarList.length > 0" class="similar-list">
      <div class="similar-item" v-for="(similar, index) in similarList" :key="index" @click="goDetail(similar)">
        <div class="img-container">
          <img :src="similar.mainPic" class="similar-img" />
        </div>
        <div class="msg-container">
          <div class="brand">{{similar.brandEnName || '未知品牌'}}</div>
          <div class="name">
            <div class="msg">{{similar.productName || '未知产品名称'}}</div>
          </div>
          <div v-if="similar.newsDetails && similar.newsDetails.length > 0" class="price-container">
          <div class="price-container">
            <van-swipe vertical class="price-swipe" :show-indicators="false" autoplay="5000">
              <van-swipe-item v-for="(newsDetail, index) in similar.newsDetails" :key="index">
                <div class="price-item">
                  <div class="label">{{newsDetail.newOld}}底价</div>
                  <div class="price">￥{{newsDetail.price/100}}</div>
                </div>
              </van-swipe-item>
            </van-swipe>
          </div>
          </div>
        </div>
        <div class="arrow-right">
          <img src="./../../../assets/images/ai-picture/right-arrow-circle.png" />
        </div>
        <div v-if="similar.saleCount > 0" class="sale-num">在售{{similar.saleCount}}件</div>
      </div>
    </div>
  </div>
</template>

<script>
import { fetchSkcInfo, fetchSimilarList, fetchMallProduct, fetchTradeList } from './../../../common/api/ai-picture'
import { Swipe, SwipeItem } from 'vant';

export default {
  components: {
    'van-swipe': Swipe,
    'van-swipe-item': SwipeItem,
  },
  data () {
    return {
      similarList: [],
      errStatus: 0,
      skcInfo: {},
      skcList: [],
    }
  },
  watch: {
    $route () {
      this.skcInfo = JSON.parse(this.$route.query.skcInfo);
      this.skcList = JSON.parse(this.$route.query.skcList);
      this.getSimilarList();
    }
  },
  methods: {
    goDetail (similar) {
      const { skc, kindId, brandId } = similar;
      this.$router.push({ path: `/ai-picture?type=1&params=${JSON.stringify({ skc, kindId, brandId })}` })
    },
    getSimilarList () {
      this.errStatus = 0;
      fetchSimilarList({ skc: this.skcInfo.skc, seriesId: this.skcInfo.seriesId, brandId: this.skcInfo.brandId, skcList: this.skcList, source: '1' })
        .then(result => {
          if (result && result.errorCode === 0) {
            this.similarList = result.skcSimilarItem;
          } else {
            this.errStatus = 1;
          }
        }, () => {
          this.errStatus = 1;
        })
    }
  },
  mounted () {
    this.skcInfo = JSON.parse(this.$route.query.skcInfo);
    this.skcList = JSON.parse(this.$route.query.skcList);
    this.getSimilarList();
  },
  created () {
  }
}
</script>
